var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCircleLeft = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 90,
  viewBox: "0 0 91 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_1907_71114)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45.9004,
  cy: 40,
  r: 25,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1907_71114)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.1504 48.5L40.6504 40L49.1504 31.5",
  stroke: "#6D6F81",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1907_71114",
  x: 0.900391,
  y: 0,
  width: 90,
  height: 90,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.101961 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1907_71114"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1907_71114",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1907_71114"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(32.9004 28)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCircleLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-circle-left.605f8dd0aaf533e4780018246a27d7de.svg";